package api.repository.visitScheduler

import api.data.DataVisitSchedule
import api.service.visitScheduler.ServiceVisitScheduler

class ImplRepositoryVisitScheduler(val serviceVisitScheduler: ServiceVisitScheduler): RepositoryVisitScheduler{
    override suspend fun getVisitSchedules(): ArrayList<DataVisitSchedule>? {
        return serviceVisitScheduler.getVisitSchedules()
    }

    override suspend fun updateVisitSchedules(dataVisitSchedule: DataVisitSchedule): Boolean {
        return serviceVisitScheduler.updateVisitSchedules(dataVisitSchedule)
    }

    override suspend fun createVisitSchedule(dataVisitSchedule: DataVisitSchedule): Boolean {
        return serviceVisitScheduler.createVisitSchedule(dataVisitSchedule)
    }

}